<template>
  <ul class="hide-list" :class="'type-' + type">
    <li v-for="(i, index) in list" :key="'i' + index" @click="handleClick(i)">
      <router-link tag="span" v-if="i.path" :to="{path:i.path,query:{lottery_type:lottery_type}}">{{i.title}}</router-link>
      <span v-else>{{i.title}}</span>
    </li>
  </ul>
</template>

<script>
  export default {
    name: "hall-hide-list",
    props: {
      list: {
        type: Array,
        default () {
          return []
        }
      },
      type: {
        type: [String, Number],
        default: 1
      },
      lottery_type:{
          type: Number,
          default:1
      }
    },
    data () {
      return {

      }
    },
    methods: {
      handleClick (item) {
        this.$emit('onItemClick', item);
      }
    }
  }
</script>

<style scoped lang="less">
  .hide-list{
    color: #333;
    padding: 6px 10px;
    font-size: 26px;
    border-radius: 10px;
    background-color: rgba(0,0,0,0.8);
     z-index: 1000;
    >li{
      padding: 14px 0;
      min-width: 180px;
      text-align: center;
      background-color: #fff;
    }
    >li~li{
      margin-top: 6px;
    }
    &:after{
      top: -10px;
      left: 50%;
      display: block;
      content: "";
      position: absolute;
      border-top: none;
      margin-left: -10px;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid rgba(0,0,0,0.8);
      z-index: 1000;
    }
    &.type-2{
      width: 602px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding-top: 0px;
      >li{
        width: 190px;
        margin-top: 6px;
        flex-shrink: 0;
      }
      >li~li{
        margin-left: 6px;
      }
      >li:nth-of-type(3n - 2) {
        margin-left: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/b-menu-list/index.vue